import { CentralizedSliderBase } from "@reusejs/react";
import LeftArrowSvg from "../../Icons/LeftArrowSvg";
import RightArrowSvg from "../../Icons/RightArrowSvg";

export interface TestimonialsSliderComponentProps {
  elements: React.ReactNode[];
}

export function TestimonialsSliderComponent(
  props: TestimonialsSliderComponentProps
) {
  const LeftArrow = (props: any) => {
    return (
      <div
        className="absolute -bottom-10 md:-bottom-12 left-1/2 -translate-x-10 z-10 scale-125 cursor-pointer opacity-70 hover:opacity-90"
        onClick={() => {
          props.swiperRef.current.slidePrev();
        }}
      >
        <LeftArrowSvg/>
      </div>
    );
  };

  const RightArrow = (props: any) => {
    return (
      <div
        className="absolute -bottom-10 md:-bottom-12 right-1/2 translate-x-10 z-10 scale-125 cursor-pointer opacity-70 hover:opacity-90"
        onClick={() => {
          props.swiperRef.current.slideNext();
        }}
      >
        <RightArrowSvg/>
      </div>
    );
  };

  return (
    <CentralizedSliderBase
      gap={20}
      slidesPerView={1}
      centeredSlides={true}
      loop={true}
      renderArrowLeft={LeftArrow}
      renderArrowRight={RightArrow}
      autoPlay={5000}
    >
      {props.elements}
    </CentralizedSliderBase>
  );
}
